import { render } from "./UploadPage.vue?vue&type=template&id=32571719&scoped=true"
import script from "./UploadPage.vue?vue&type=script&lang=js"
export * from "./UploadPage.vue?vue&type=script&lang=js"

import "./UploadPage.vue?vue&type=style&index=0&id=32571719&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32571719"]])

export default __exports__